import { Context, createContext, useContext } from "react";

import { EditFormMode, RydeUiUnit } from "@ryde/shared";

import { IEditFormData } from "../hooks";

export interface ICrudEditContext<T> {
  data: IEditFormData<T>;
  entity: RydeUiUnit;
  mode?: EditFormMode;
  idCopyFrom?: number;
  id?: number;
}

const getInitialContext = <T>(): ICrudEditContext<T> => {
  return {
    data: {} as IEditFormData<T>,
    entity: "unknown" as RydeUiUnit,
    mode: EditFormMode.CrudRoute,
  };
};

const createCrudEditContext = <T>(): Context<ICrudEditContext<T>> => {
  return createContext<ICrudEditContext<T>>(getInitialContext<T>());
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const CrudEditContext = createCrudEditContext<any>();

CrudEditContext.displayName = "Crud Edit";

export const useCrudEditContext = <T>(): ICrudEditContext<T> =>
  useContext(CrudEditContext);

export { CrudEditContext };
